import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import { Redirect } from 'react-router';
import { MDBDataTableV5 } from 'mdbreact';
import axios from 'axios';

import ReactFileReader from 'react-file-reader';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import '../../assets/scss/app-styles/users.scss'
import CallingNumberModal from './callingNumberModal';


class Extensions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newRecordClicked: false,
            userIdSelected: null,
            style: 'custom-spinner',
            loading: true,
            backToIndex: false,
            callingNumberModal: false,
            availableCallingNumbers: [],
            selectedCallingPhoneNumber: "",
            extensionSelected: "",
            selectedDomain: ""
        };
    }
    headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData = () => {
        this.setState({ style: 'custom-spinner' });
        const payLoad = {
            user_id: JSON.parse(localStorage.getItem('creds')).id,
        };

        axios.post(`${process.env.REACT_APP_API_URL}getExtensionsSummary`, payLoad, this.headers)
            .then(response => {
                this.createDataTable(response.data);
                this.setState({ style: 'custom-spinner-hide' });
            })
            .catch(err => {
                toast.error(err.message);
                this.setState({ style: 'custom-spinner-hide' });
            });
    }

    createDataTable = (dataFromApi) => {

        let columns = [
            {
                label: 'Id',
                field: 'id',
            },
            {
                label: 'Name',
                field: 'name',
            },
            {
                label: 'Username',
                field: 'username',
            },
            {
                label: 'UID',
                field: 'uid',
            },
            {
                label: 'Login',
                field: 'login',
            },
            {
                label: 'Extension',
                field: 'extension',
            },
            {
                label: 'Domain',
                field: 'domain',
            },
            {
                label: 'Caller ID',
                field: 'option',
            },
            {
                label: 'Delete',
                field: 'edit',
                sort: 'disabled',
            }
        ];

        let dataModified = null;
        if (dataFromApi != null) {
            dataModified = dataFromApi.map((row) => {
                return ({
                    ...row,
                    edit: (
                        <div className="edit-column">
                            <i
                                className="far fa-trash-alt data-table-icon"
                                onClick={this.deleteHandler}
                                data-id={row.id}
                                data-uid={row.uid}
                            ></i>
                        </div>
                    ),
                    option: (
                        <span
                            className="option-column"
                            onClick={e => this.callerIdHandler(row.domain, row.extension)}
                            style={{ cursor: "pointer", color: "#007bff", display: "flex", alignItems: "center", gap: "8px" }}
                        >
                            <i className="fas fa-phone-alt"></i>
                        </span>
                    )

                });
            });

        }
        this.setState({ dataTable: { columns: columns, rows: dataModified } });
        this.setState({ loading: false });
    }

    deleteHandler = (event) => {

        confirmAlert({
            title: 'Are you sure you want to delete this Extension?',
            message: '',
            buttons: [
                {
                    label: 'Delete',
                    onClick: () => {
                        const payLoad = {
                            id: event.target.getAttribute("data-id"),
                            uid: event.target.getAttribute("data-uid"),
                            user_id: JSON.parse(localStorage.getItem('creds')).id,
                        };
                        this.setState({ style: 'custom-spinner' });
                        axios.post(`${process.env.REACT_APP_API_URL}deleteExtensions`, payLoad, this.headers)
                            .then(response => {
                                toast.success("Record Deleted");
                                this.setState({ style: 'custom-spinner-hide' });
                                this.refreshData();
                            })
                            .catch(err => {
                                toast.error(err.message);
                                this.setState({ style: 'custom-spinner-hide' });
                            });
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                    }
                }
            ]

        });
    }

    toggleCallingNumberHandler = () => {
        this.setState({ callingNumberModal: !this.state.callingNumberModal });
    }

    refreshCallingIdLists = (user, extension) => {

        let payLoad = {
            domain: user,
            user: extension,
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
        }
        this.setState({ style: 'custom-spinner' });

        // First get assigned numbers
        axios.post(`${process.env.REACT_APP_API_URL}getAssignedCallingNumbers`, payLoad, this.headers)
            .then(assignedResponse => {
                // Process assigned numbers
                let assignedNumbers = [];
                if (assignedResponse.data && Array.isArray(assignedResponse.data)) {
                    assignedNumbers = assignedResponse.data.map(row => row.phone_number);
                }

                // Process assigned numbers for table
                let assignedColumns = [
                    {
                        label: 'Phone Number',
                        field: 'phone_number',
                    },
                    {
                        label: 'Extension',
                        field: 'extension',
                    },
                    {
                        label: 'Domain',
                        field: 'domain',
                    },
                    {
                        label: 'Delete',
                        field: 'edit',
                        sort: 'disabled',
                    }
                ];

                let assignedDataModified = null;
                if (assignedResponse.data && Array.isArray(assignedResponse.data)) {
                    assignedDataModified = assignedResponse.data.map((row) => ({
                        ...row,
                        edit: <div className="edit-column">
                            <i className="far fa-trash-alt data-table-icon"
                                onClick={e => this.removePhoneNumberHandler(row.phone_number)}
                            ></i>
                        </div>
                    }));
                }

                this.setState({ assignedCallingNumbers: { columns: assignedColumns, rows: assignedDataModified || [] } });

                // Now get available numbers
                axios.post(`${process.env.REACT_APP_API_URL}getAvailableCallingNumbers`, payLoad, this.headers)
                    .then(availableResponse => {
                        // Process available numbers and filter out assigned ones
                        let availableItems = [];
                        if (availableResponse.data && Array.isArray(availableResponse.data)) {
                            availableItems = availableResponse.data
                                .filter(row => !assignedNumbers.includes(row.phone_number))
                                .map(row => ({
                                    phone_number: row.phone_number ? row.phone_number.toString() : ''
                                }))
                                .filter(item => item.phone_number);
                        }

                        this.setState({
                            availableCallingNumbers: availableItems,
                            callingNumberModal: true,
                            style: 'custom-spinner-hide'
                        });
                    })
                    .catch(err => {
                        toast.error(err.message);
                        this.setState({ style: 'custom-spinner-hide' });
                    });
            })
            .catch(err => {
                toast.error(err.message);
                this.setState({ style: 'custom-spinner-hide' });
            });
    }
    callerIdHandler = (user, extension) => {
        this.setState({ extensionSelected: extension })
        this.setState({ selectedDomain: user })
        this.refreshCallingIdLists(user, extension);
    }
    removePhoneNumberHandler = (phoneNumber) => {
        console.log("Delete Phonenumber " + phoneNumber);
        const payLoad = {
            phone_number: phoneNumber,
            domain: this.state.selectedDomain,
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
        };
        this.setState({ style: 'custom-spinner' });
        axios.post(`${process.env.REACT_APP_API_URL}deleteAssignedCallingNumber`, payLoad, this.headers)
            .then(response => {
                // Refresh the lists to show updated data
                this.refreshCallingIdLists(this.state.selectedDomain, this.state.extensionSelected);
                toast.success("Number removed successfully!");
            })
            .catch(err => {
                toast.error(err.message);
                this.setState({ style: 'custom-spinner-hide' });
            });
    }

    CallingNumberChangeHandler = (event) => {
        if (event && event.target) {
            this.setState({ selectedCallingPhoneNumber: event.target.value });
        }
    }
    saveCallingNumberHandler = () => {
        if (!this.state.selectedCallingPhoneNumber) {
            toast.error("Please select the calling number first!")
            return;
        }
        const payLoad = {
            domain: this.state.selectedDomain,
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
            extension: this.state.extensionSelected,
            phone_number: this.state.selectedCallingPhoneNumber
        }
        this.setState({ style: 'custom-spinner' });
        axios.post(`${process.env.REACT_APP_API_URL}assignCallingNumber`, payLoad, this.headers)
            .then(response => {
                this.setState({
                    style: 'custom-spinner-hide',
                    selectedCallingPhoneNumber: ""
                });
                // Refresh the lists to show updated data
                this.refreshCallingIdLists(this.state.selectedDomain, this.state.extensionSelected);
                toast.success("Number assigned successfully!");
            })
            .catch(err => {
                toast.error(err.message);
                this.setState({ style: 'custom-spinner-hide' });
            });
    }
    handleFiles = (files) => {
        var reader = new FileReader();
        const scope = this;
        reader.onload = function (e) {
            // Use reader.result
            const csv = reader.result;
            const lines = csv.split('\n');
            const result = [];
            const headers = ['name', 'username', 'uid', 'login', 'extension', 'domain'];
            let key = null;
            let value = null;

            if (!lines[0].includes(`name,username,uid,login,extension,domain`)) {
                toast.error("Invalid Format");
                scope.setState({ csvData: null, CSVProcessed: false });
                return;
            }
            for (let i = 1; i < lines.length; i++) {

                if (!lines[i])
                    continue;
                lines[i] = lines[i].replaceAll(`"`, ``)
                const obj = {};
                const currentline = lines[i].split(',');
                for (let j = 0; j < headers.length; j++) {
                    key = headers[j];
                    value = currentline[j].replace('\r', '');
                    obj[key] = value;

                }
                result.push(obj);
            }

            scope.setState({ csvData: result, CSVProcessed: true });


            let payLoad = {
                user_id: JSON.parse(localStorage.getItem('creds')).id,
                extensions: result
            }
            axios.post(`${process.env.REACT_APP_API_URL}addExtensions`, payLoad, scope.headers)
                .then(response => {

                    scope.refreshData();
                })
                .catch(err => {
                    if (err.response) {
                        if (err.response.data.includes("unique_extensions")) {
                            toast.error("Some of the records in CSV file already exists. Please add unique records!");
                        }

                    } else {
                        toast.error(err.message);
                    }

                    scope.setState({ loading: false });
                });
        };

        reader.readAsText(files[0]);
    };

    downloadSampleTemplate = () => {
        const headers = ['name', 'username', 'uid', 'login', 'extension', 'domain'];
        const sampleData = [
            'John Doe,johndoe,12345,johndoe@saevolgo.com,1001,SAEVOLGO',
            'Jane Smith,janesmith,12346,janesmith@saevolgo.com,1002,SAEVOLGO'
        ];

        const csvContent = [headers.join(','), ...sampleData].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'extension_template.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    render() {

        let redirect = null;

        if (this.state.backToIndex) {
            redirect = <Redirect to={{
                pathname: "/dashboard"
            }} />;
        }

        return (
            <Fragment>

                <Breadcrumb parent="App" title="Extension Management" />
                <div className={"loader-box " + this.state.style} >
                    <div className="loader">
                        <div className="line bg-primary"></div>
                        <div className="line bg-primary"></div>
                        <div className="line bg-primary"></div>
                        <div className="line bg-primary"></div>
                    </div>
                </div>
                {redirect}
                <CallingNumberModal
                    show={this.state.callingNumberModal}
                    toggleHandler={this.toggleCallingNumberHandler}
                    availableCallingNumbers={this.state.availableCallingNumbers}
                    assignedCallingNumbers={this.state.assignedCallingNumbers}
                    CallingNumberChangeHandler={this.CallingNumberChangeHandler}
                    saveCallingNumberHandler={this.saveCallingNumberHandler}
                    selectedUser={this.state.extensionSelected}
                    selectedCallingPhoneNumber={this.state.selectedCallingPhoneNumber}
                />
                <div className="MainIndex">
                    <ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'} >
                        <button className='btn btn-dark' style={{ marginRight: "5px", float: "right" }} >Import</button>
                    </ReactFileReader>
                    <div className="users-table">
                        <MDBDataTableV5 hover entriesOptions={[10, 20, 30]} entries={10}
                            pagesAmount={4} data={this.state.dataTable} searchTop searchBottom={false} />

                    </div>
                </div>

            </Fragment>

        );

    }

}

export default Extensions;
